import instance from '@apis/instance';
import {
    GetOrderLogsParams, OrderResponse, OrderRow, RecentOrdersResponse,
} from '@models/order/orderLog';
import { SliceResponse } from '@models/page';

class OrderLogApi {
    static getOrderLogs(params: GetOrderLogsParams):Promise<SliceResponse<OrderRow>> {
        return instance.get('/v0/orders', { params });
    }

    static getOrderLog(orderNo: string) : Promise<OrderResponse> {
        return instance.get(`/v1/order/${orderNo}`);
    }
}

export default OrderLogApi;
